import axios from "infra/http";
import { useQuery } from "react-query";
import { VotacaoVotosPorPerguntaItem } from "../typings";

function useVotosPorPergunta(votacaoId: string, enabled = true) {
  return useQuery(
    `/v1/votacao/${votacaoId}/votos-por-pergunta`,
    async () => {
      const res = await axios.get<VotacaoVotosPorPerguntaItem[]>(
        `/v1/votacao/${votacaoId}/votos-por-pergunta`
      );

      return res.data;
    },
    {
      enabled: !!votacaoId,
    }
  );
}

export default useVotosPorPergunta;
